<script setup lang="ts">
import { computed } from 'vue';
import { salesforceAccountUrl } from '@/utilities/Account';
import { CanAccessSalesforce } from '@/utilities/AuthUtils';
import store from '@/store';

const props = withDefaults(
  defineProps<{
    salesForceId?: string | null;
    size?: number;
  }>(),
  { size: 28 },
);

const url = computed(() => (CanAccessSalesforce(store.state.user) ? salesforceAccountUrl(props.salesForceId) : null));
const height = computed(() => Math.round((props.size * 22) / 28));
</script>

<template>
  <div v-if="url" class="tooltip tooltip-bottom flex items-center" data-tip="View in Salesforce">
    <a
      :href="url"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center"
      data-test="salesforce-link"
      aria-label="View in Salesforce">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        :width="size"
        :height="height"
        fill="#00A1E0"
        aria-hidden="true">
        <path
          d="M10.006 5.415a4.195 4.195 0 0 1 3.045-1.306c1.56 0 2.954.9 3.69 2.205.63-.3 1.35-.42 2.1-.42 2.85 0 5.145 2.34 5.145 5.234 0 2.895-2.31 5.235-5.145 5.235-.345 0-.69-.03-1.02-.105-.63 1.155-1.845 1.936-3.24 1.936-.585 0-1.14-.15-1.62-.375-.66 1.53-2.205 2.61-3.99 2.61-1.867.006-3.503-1.199-4.081-3.007-.256.05-.503.078-.766.078-2.354 0-4.185-1.816-4.185-4.171 0-1.53.816-2.878 2.086-3.63a4.79 4.79 0 0 1-.394-1.916c0-2.669 2.174-4.83 4.845-4.83 1.545 0 2.94.72 3.84 1.845" />
      </svg>
    </a>
  </div>
</template>
